import React from "react";
import { useTranslation } from "react-i18next";
import "./ReasonModal.styles.scss";

const ReasonModal = ({
  isOpen,
  reason,
  changedCount,
  onReasonChange,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const isValid = reason.trim() !== "";

  return (
    <div className={`reason_modal ${isOpen ? "open" : ""}`}>
      <div className="reason_modal-content">
        <div className="reason_modal-header">
          <h2>{t("system_settings.reasonTitle")}</h2>
          <button className="reason_modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="reason_modal-body">
          <p className="reason_modal-summary">
            {t("system_settings.changesCount", { changes: changedCount })}
          </p>
          <textarea
            className="reason_modal-input"
            rows={3}
            value={reason}
            placeholder={t("system_settings.reasonPlaceholder")}
            onChange={(e) => onReasonChange(e.target.value)}
          />
          {!isValid && (
            <p className="reason_modal-error">
              {t("system_settings.reasonRequired")}
            </p>
          )}
        </div>
        <div className="reason_modal-footer">
          <button
            className="reason_modal-confirm"
            disabled={!isValid}
            onClick={onConfirm}
          >
            {t("system_settings.confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ReasonModal);
